<template>
  <div class="tabs-list" :class="{'tabs-list--large': isLarge}">
    <div
      class="tabs-list__tab"
      :class="{
      'tabs-list__tab--selected': selected === tab, }"
      @click="onSelect(tab)"
      v-for="tab in tabs"
      :key="tab"
    >
      {{ tab }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      default: () => ['Byt', 'Erstat', 'Ledigt personale']
    },
    selected: {
      type: String,
      default: 'Byt'
    },
    isLarge: {
      default: false,
      type: Boolean
    }
  },
  methods: {
    onSelect (tab) {
      this.$emit('select', tab)
    }
  }
}
</script>
<style scoped>
.tabs-list {
  color: #8898aa;
  padding: 2px 4px;
  background-color: #f6f9fc;
  border-radius: 0.25rem;
  display: inline-flex;
  align-items: center;
  gap: 0rem;
}

.tabs-list.tabs-list--large {
  font-weight: bold;
  padding: 0.5rem;
}

.tabs-list__tab {
  cursor: pointer;
  padding: 2px 8px;
}

.tabs-list.tabs-list--large .tabs-list__tab {
  padding: 2px 12px;
}

.tabs-list__tab.tabs-list__tab--selected {
  color: #09090b;
  background-color: #fff;
  border-radius: 0.25rem;
  white-space: nowrap;
  --tw-ring-color: rgba(59, 130, 246, .5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow-color: #fff;
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px -1px rgba(0, 0, 0, .1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
</style>



// WEBPACK FOOTER //
// Tabslist.vue?7721fb3a